import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import { LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import { get_cookies, isLoggedIn } from "../../components/Cookies/Cookies";
import Preloader from "../../components/Preloader/Preloader";

const Sales = () => {
	const x = 0;
	const [contentNav, setContentNav] = useState("");
	useEffect(() => {
		//
		getContentNavData();
	}, []);
	useEffect(() => {
		//
		isLoggedIn();
	}, [x]);
	const getContentNavData = async () => {
		await axios
			.get(process.env.REACT_APP_API_URL + "get_content_nav_data", {
				params: {
					name: "sales", //
					content_nav: get_cookies("content.nav.access")
				}
			})
			.then(function (res) {
				setContentNav(res.data.data);
			})
			.catch(function (error) {
				// console.log(error);
			});
	};
	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<h4 className="header-title">Sales</h4>
			</div>
			<div className="page-container">
				<Grid container spacing={2}>
					{contentNav ? (
						contentNav.map(item => {
							if ((item.cn_name === 'MC/TC Purchase Order' && get_cookies('branchtype') != "BCO") || item.cn_hasline !== -1) return null;
							return item.cn_hasline == -1 ? (
								<Grid
									item
									xs={12}
									sm={6}
									className="app-card-container"
									key={item.id}
									style={{
										"--cardBorderColor": item.nav_color
									}}
								>
									<NavLink to={item.cn_url} key={item.id}>
										<div className="app-card">
											{item.cn_name}
										</div>
									</NavLink>
								</Grid>
							) : null;
						})
					) : (
						(<Preloader />)
					)}
				</Grid>
			</div>
		</div>
	);
};

export default Sales;
